import React from "react";
import { Route, Routes } from "react-router-dom";
import Intro from "./Intro";
import Input from "./Input";
import Result from "./Result";
import History from "./History";

function App(props) {
  const { user } = props;
  return (
    <div>
      <Routes>
        <Route path="/" element={<Intro user={user} />} />
        <Route path="/intro" element={<Intro user={user} />} />
        <Route path="/input" element={<Input user={user} />} />
        <Route path="/result" element={<Result user={user} />} />
        <Route path="/history" element={<History user={user} />} />
      </Routes>
    </div>
  );
}

export default App;
